export const FILE_MODAL_SEARCH_KEYS = {
  objectType: "objectType",
  entityID: "entityID",
  disableActions: "disableActions",
} as const;

export function isFileModalDocsPath(
  pathname: string,
  baseURL: string,
): boolean {
  return pathname === `${baseURL}/docs`;
}

/** True for any nested `…/docs` route (e.g. payments or lease docs). */
export function isAnyFileModalDocsPath(pathname: string): boolean {
  return pathname.endsWith("/docs");
}

export function isFileModalOpenForEntity(
  pathname: string,
  search: string,
  baseURL: string,
  entityID: string,
  entityType: string,
): boolean {
  if (!isFileModalDocsPath(pathname, baseURL)) {
    return false;
  }
  const params = new URLSearchParams(search);
  return (
    params.get(FILE_MODAL_SEARCH_KEYS.entityID) === entityID &&
    params.get(FILE_MODAL_SEARCH_KEYS.objectType) === entityType
  );
}

export function buildFileModalDocsSearch(
  currentSearch: string,
  entityType: string,
  entityID: string,
  disableActions?: boolean,
): string {
  const params = new URLSearchParams(currentSearch);
  params.set(FILE_MODAL_SEARCH_KEYS.objectType, entityType);
  params.set(FILE_MODAL_SEARCH_KEYS.entityID, entityID);
  params.set(
    FILE_MODAL_SEARCH_KEYS.disableActions,
    String(!!disableActions),
  );
  return params.toString();
}

export function buildFileModalCloseSearch(currentSearch: string): string {
  const params = new URLSearchParams(currentSearch);
  params.delete(FILE_MODAL_SEARCH_KEYS.objectType);
  params.delete(FILE_MODAL_SEARCH_KEYS.entityID);
  params.delete(FILE_MODAL_SEARCH_KEYS.disableActions);
  return params.toString();
}
